module.exports = __webpack_public_path__ + "static/img/EN.367c0bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/userTips/EN.png
// module id = +2J5
// module chunks = 1